import {defineMessages} from 'react-intl';

export const groupHistoryMessages = defineMessages({
    internalEncrypted: {id: 'callSurface.history.internal-encrypted', defaultMessage: 'Internal call · Encrypted'},
    startCall: {id: 'callSurface.history.start-call', defaultMessage: 'Start call'},
    openChat: {id: 'callSurface.history.open-chat', defaultMessage: 'Open chat'},
    detailsRegion: {id: 'callSurface.history.details-region', defaultMessage: 'Call details'},
    date: {id: 'callSurface.history.date', defaultMessage: 'Date'},
    length: {id: 'callSurface.history.length', defaultMessage: 'Call length'},
    lengthValue: {id: 'callSurface.history.length-value', defaultMessage: '{minutes} min {seconds} s'},
    type: {id: 'callSurface.history.type', defaultMessage: 'Type'},
    typeValue: {id: 'callSurface.history.type-value', defaultMessage: '{intent, select, video {Video · group} audio {Voice · group} other {Group call}}'},
    intentShort: {id: 'callSurface.history.intent-short', defaultMessage: '{intent, select, video {Video} other {Voice}}'},
    result: {id: 'callSurface.history.result', defaultMessage: 'You'},
    chat: {id: 'callSurface.history.chat', defaultMessage: 'Chat'},
    chatValue: {id: 'callSurface.history.chat-value', defaultMessage: '{room} · {count, plural, one {# member} other {# members}}'},
});
